import React from 'react';
import { OverlayDrawerComponentProps } from '@sharefiledev/sharefile-appshell';

const LazyEditContactTableColumnsDrawer = React.lazy(
	() => import('../components/ContactsTable/EditColumns')
);
export const EditColumnsDrawer: React.FC<
	OverlayDrawerComponentProps<'urn:sfdrawer:client-mgt-pilet:client-contacts:edit-columns'>
> = ({ piral, options, cancelInteraction, completeInteraction }) => {
	if (!options || !options.columnSelections) {
		return <div data-testid="add-service-contacts-drawer-error" />;
	}
	return (
		<React.Suspense fallback={<div data-testid="loading-edit-columns-drawer" />}>
			<LazyEditContactTableColumnsDrawer
				initialParameters={{
					columnSelections: options?.columnSelections,
					fixedColumns: options?.fixedColumns,
					piral,
					cancelInteraction,
					completeInteraction,
				}}
			/>
		</React.Suspense>
	);
};
